import { Flex, Divider, Form, FormInstance } from "antd";
import { CustomButton, PasswordInput } from "ui";
import {
  _isRequired,
  _isLengthBetween,
  _noForbiddenSymbols,
  _includesLatin,
  _includesSpecialSymbol,
  _includesNumbers,
  _isTheSameAs,
} from "utils";

import styles from "./changePasswordForm.module.css";

interface IProps {
  form: FormInstance<any>;
  disabled: boolean;
  onFinish: () => void;
  cancelHandler?: () => void;
}

export const ChangePasswordForm = ({ form, onFinish, disabled, cancelHandler }: IProps) => {
  return (
    <Form
      form={form}
      name="changePassword"
      initialValues={{
        currentPassword: "",
        newPassword: "",
        newPasswordRepeat: "",
      }}
      onFinish={onFinish}
      className={styles.loginForm}
      layout="vertical"
    >
      <Flex vertical>
        <Form.Item name="currentPassword" rules={[_isRequired("Текущий пароль обязателен для ввода")]}>
          <PasswordInput placeholder="Текущий пароль" disabled={disabled} autoComplete="current-password" />
        </Form.Item>

        <Divider className="divider margin-bottom-lg" />

        <Form.Item
          name="newPassword"
          rules={[
            _isRequired("Новый пароль обязателен для ввода"),
            _isLengthBetween(8, 40),
            _noForbiddenSymbols("Вы используете запрещенный символ"),
            _includesLatin("Необходимо использовать хотя бы один латинский символ"),
            _includesSpecialSymbol("Необходимо использовать хотя бы один специальный символ (! . , - _ @ # $ % ^ &)"),
            _includesNumbers("Необходимо использовать хотя бы одну цифру"),
          ]}
        >
          <PasswordInput placeholder="Новый пароль" disabled={disabled} autoComplete="new-password" />
        </Form.Item>

        <Form.Item
          name="newPasswordRepeat"
          rules={[_isRequired("Повторите новый пароль"), _isTheSameAs("newPassword", "Пароли не совпадают")]}
        >
          <PasswordInput placeholder="Повторите новый пароль" disabled={disabled} autoComplete="new-password" />
        </Form.Item>

        <Divider className="divider margin-bottom-lg" />

        <Flex gap="middle">
          <Form.Item className="full-width">
            <CustomButton htmlType="submit" disabled={disabled} className="full-width">
              Подтвердить
            </CustomButton>
          </Form.Item>
          {cancelHandler && (
            <Form.Item className="full-width">
              <CustomButton htmlType="button" type="default" onClick={cancelHandler}>
                Отменить
              </CustomButton>
            </Form.Item>
          )}
        </Flex>
      </Flex>
    </Form>
  );
};
